module.exports = __webpack_public_path__ + "img/coperta_teste.0f4c326b.png";